import store from "../store-root";
import api from "../../service/api";
import queryString from "querystring";

const moduleName = "report";

store.registerModule(moduleName, {
  namespaced: true,
  actions: {
    //生产报表
    async GetProductionReport({ commit }, payload) {
      let result = await api.get(
        `/api/ProductionReport?${queryString.stringify(payload)}`
      );
      return result.data;
    },
    // 预估产出表
    async GetEstimatedProductionReport({ commit }, payload) {
      let result = await api.get(
        `/api/ProductionReport/GetEstimatedProductionReport?${queryString.stringify(payload)}`
      );
      return result.data;
    },
    // 生产利润表
    async GetProductionProfitReport({ commit }, payload) {
      let result = await api.get(
        `/api/ProductionReport/GetProductionProfitReport?${queryString.stringify(payload)}`
      );
      return result.data;
    },
    //预估存塘报表
    async GetStoragePondReport({ commit }, payload) {
      let result = await api.get(
        `/api/ProductionReport/GetStoragePondReport?${queryString.stringify(payload)}`
      );
      return result.data;
    },
    //出塘报表
    async GetOutPondReport({ commit }, payload) {
      let result = await api.get(
        `/api/SaleReport?${queryString.stringify(payload)}`
      );
      return result.data;
    },
    //损失报表
    async GetLossReport({ commit }, payload) {
      let result = await api.get(
        `/api/LossReport?${queryString.stringify(payload)}`
      );
      return result.data;
    },
    //物资耗用报表
    async getMaterialReport({ commit }, payload) {
      let result = await api.get(
        `/api/MaterialReport?${queryString.stringify(payload)}`
      );
      return result.data;
    },
    //物资耗用报表
    async getStockReport({ commit }, payload) {
      let result = await api.get(
        `/api/StockReport?${queryString.stringify(payload)}`
      );
      return result.data;
    }
  }
});

export default moduleName;
